export const META_SET_PREFERENCES = 'META_SET_PREFERENCES';
export const META_CLEAR_DISMISSED_BANNER_ALERTS = 'META_CLEAR_DISMISSED_BANNER_ALERTS';
